import { useState } from "react";
import { nextSpotlight } from "@/lib/multi-view";

/**
 * Which recipe holds the spotlight: the cook's pick, kept until it leaves the
 * view, and, with auto-focus on, whichever recipe has just gone late.
 *
 * Worked out while rendering (the same pattern as `useLiveSeconds`) so the
 * spotlight never shows a recipe that has left, even for one frame.
 */
export function useSpotlight(ids: number[], lateIds: number[], autoFocusLate: boolean) {
  const key = `${ids.join(",")}|${lateIds.join(",")}|${autoFocusLate}`;
  const [state, setState] = useState<{ current: number | null; previousLate: number[]; key: string }>({
    current: null,
    previousLate: [],
    key: "",
  });

  if (state.key !== key) {
    setState({
      current: nextSpotlight({ current: state.current, ids, lateIds, previousLateIds: state.previousLate, autoFocusLate }),
      previousLate: lateIds,
      key,
    });
  }

  const pick = (id: number) => setState((s) => ({ ...s, current: id }));
  return [state.current, pick] as const;
}
